import React, { useCallback } from 'react'
import { closeModal, GLOBAL_MODAL_TYPE, selectIsModalOpen } from 'state/constants'
import { useDispatch, useSelector } from 'react-redux'
import { useNewTranslation } from 'hooks/index'
import { selectSelectedPriorityListUuids } from 'state/review'
import Modal from 'particles/Modal'

interface ConfirmModalProps {
    onConfirm: any
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({ onConfirm }) => {
    const [newT] = useNewTranslation()
    const dispatch = useDispatch()
    const isModalOpen = useSelector(selectIsModalOpen(GLOBAL_MODAL_TYPE.INTEREST_REGISTRATION_BACK_TO_WAITLIST))
    const selectedPriorityListUuids = useSelector(selectSelectedPriorityListUuids)
    const onCloseModal = useCallback(() => dispatch(closeModal()), [])

    const handleCLickConfirm = (): void => {
        onConfirm(selectedPriorityListUuids)
        onCloseModal()
    }

    return isModalOpen ? (
        <Modal
            title={newT('modalWindow.removeAllFromPriorityListTitle')}
            subtext={newT('modalWindow.removeAllFromPriorityListSubtitle')}
            hasIcon={false}
            primaryButtonProps={{
                label: newT('button.yesDelete'),
            }}
            secondaryButtonProps={{
                label: newT('button.noGoBack'),
            }}
            size="m"
            isClosable={false}
            onConfirm={handleCLickConfirm}
            onClose={onCloseModal}
        />
    ) : null
}

export default ConfirmModal
